import { render, staticRenderFns } from "./utils-popup-input-text.vue?vue&type=template&id=5545d652&scoped=true"
import script from "./utils-popup-input-text.vue?vue&type=script&lang=js"
export * from "./utils-popup-input-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545d652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5545d652')) {
      api.createRecord('5545d652', component.options)
    } else {
      api.reload('5545d652', component.options)
    }
    module.hot.accept("./utils-popup-input-text.vue?vue&type=template&id=5545d652&scoped=true", function () {
      api.rerender('5545d652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/popups/utils-popup-input-text.vue"
export default component.exports